export enum MemberLookupActionTypes {
  REGISTER_START = '@@memberLookup/REGISTER_START',
  REGISTER_SUCCESS = '@@memberLookup/REGISTER_SUCCESS',
  REGISTER_FAILURE = '@@memberLookup/REGISTER_FAILURE',
  CLEAR_MAP_SKETCH_REGISTRATION = '@@memberLookup/CLEAR_MAP_SKETCH_REGISTRATION',

  UPLOAD_FILE_START = '@@memberLookup/UPLOAD_FILE_START',
  UPLOAD_FILE_SUCCESS = '@@memberLookup/UPLOAD_FILE_SUCCESS',
  UPLOAD_FILE_FAILURE = '@@memberLookup/UPLOAD_FILE_FAILURE',
  CLEAR_FILE_UPLOAD = '@@memberLookup/CLEAR_FILE_UPLOAD',

  POLL_JOB_START = '@@memberLookup/POLL_JOB_START',
  POLL_JOB_UPDATE = '@@memberLookup/POLL_JOB_UPDATE',
  POLL_JOB_COMPLETE = '@@memberLookup/POLL_JOB_COMPLETE',
  POLL_JOB_FAILURE = '@@memberLookup/POLL_JOB_FAILURE',

  FETCH_LIVE_PRICE_START = '@@memberLookup/FETCH_LIVE_PRICE_START',
  FETCH_LIVE_PRICE_SUCCESS = '@@memberLookup/FETCH_LIVE_PRICE_SUCCESS',
  FETCH_LIVE_PRICE_FAILURE = '@@memberLookup/FETCH_LIVE_PRICE_FAILURE',

  CREATE_CHECKOUT_START = '@@memberLookup/CREATE_CHECKOUT_START',
  CREATE_CHECKOUT_SUCCESS = '@@memberLookup/CREATE_CHECKOUT_SUCCESS',
  CREATE_CHECKOUT_FAILURE = '@@memberLookup/CREATE_CHECKOUT_FAILURE',
  CONFIRM_POSTPAY = '@@memberLookup/CONFIRM_POSTPAY',
  RESET_PAYMENT_CHECKOUT = '@@memberLookup/RESET_PAYMENT_CHECKOUT',

  POLL_CHECKOUT_STATUS_START = '@@memberLookup/POLL_CHECKOUT_STATUS_START',
  POLL_CHECKOUT_STATUS_COMPLETE = '@@memberLookup/POLL_CHECKOUT_STATUS_COMPLETE',
  POLL_CHECKOUT_STATUS_FAILURE = '@@memberLookup/POLL_CHECKOUT_STATUS_FAILURE',

  POLL_STATUS_START = '@@memberLookup/POLL_STATUS_START',
  POLL_STATUS_UPDATE = '@@memberLookup/POLL_STATUS_UPDATE',
  POLL_STATUS_COMPLETE = '@@memberLookup/POLL_STATUS_COMPLETE',
  POLL_STATUS_FAILURE = '@@memberLookup/POLL_STATUS_FAILURE',

  FETCH_DOWNLOAD_URL_START = '@@memberLookup/FETCH_DOWNLOAD_URL_START',
  FETCH_DOWNLOAD_URL_SUCCESS = '@@memberLookup/FETCH_DOWNLOAD_URL_SUCCESS',
  FETCH_DOWNLOAD_URL_FAILURE = '@@memberLookup/FETCH_DOWNLOAD_URL_FAILURE',

  RESET = '@@memberLookup/RESET',
  RESTORE_LOOKUP_ID = '@@memberLookup/RESTORE_LOOKUP_ID'
}

export type MemberLookupInputMode = 'MAP_SKETCH' | 'FILE_UPLOAD' | null;

export type MemberLookupJobStatus =
  | 'PENDING'
  | 'PROCESSING'
  | 'COMPLETED'
  | 'FAILED';

export type MemberLookupProcessingPhase =
  | 'IDLE'
  | 'UPLOADING_FILE'
  | 'FILE_UPLOAD_READY'
  | 'VALIDATING_FILE'
  | 'FILE_VALIDATED'
  | 'REGISTERING'
  | 'AWAITING_PAYMENT'
  | 'CONFIRMING_PAYMENT'
  | 'PAYMENT_EXPIRED'
  | 'FINDING_MEMBERS'
  | 'COMPLETED'
  | 'ERROR';

export type MemberLookupPaymentStatus =
  | 'idle'
  | 'creating'
  | 'confirming'
  | 'checkout'
  | 'invoice'
  | 'failed';

export interface LivePrice {
  paymentType: string;
  currency: string;
  priceIncludeTax: boolean;
  unitAmount: number;
  unitAmountDecimal: string;
}

export interface MemberLookupState {
  inputMode: MemberLookupInputMode;
  loading: boolean;
  error: string | null;

  fileId: number | null;
  uploadError: string | null;
  shapeCount: number | null;
  areaKm2: number | null;

  lookupId: number | null;
  registrationJobId: number | null;
  jobStatus: MemberLookupJobStatus | null;
  processingPhase: MemberLookupProcessingPhase;
  lookupStatus: string | null;

  livePrice: LivePrice | null;
  livePriceLoading: boolean;
  livePriceError: string | null;
  paymentStatus: MemberLookupPaymentStatus;
  clientSecret: string | null;
  checkoutSessionId: string | null;
  transactionReference: string | null;
  paymentError: string | null;
  postPaymentId: number | null;

  memberCount: number | null;
  fileName: string | null;
}

export const INITIAL_MEMBER_LOOKUP_STATE: MemberLookupState = {
  inputMode: null,
  loading: false,
  error: null,
  fileId: null,
  uploadError: null,
  shapeCount: null,
  areaKm2: null,
  lookupId: null,
  registrationJobId: null,
  jobStatus: null,
  processingPhase: 'IDLE',
  lookupStatus: null,
  livePrice: null,
  livePriceLoading: false,
  livePriceError: null,
  paymentStatus: 'idle',
  postPaymentId: null,
  clientSecret: null,
  checkoutSessionId: null,
  transactionReference: null,
  paymentError: null,
  memberCount: null,
  fileName: null
};
